import React from "react";
import { observer } from "mobx-react";
import Card from "@app/components/search/card";

const Search = observer(({ data }) => {
    return <Card search={data} readonly={true} showRibbon={false} />;
});

export default Search;
